import { cpf, phone } from '@polvo-labs/form-utils'
import { Fetch, useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Avatar from '../../../../components/Avatar'
import Button from '../../../../components/Button'
import NewMessage from '../../../../components/Chat/NewMessage'
import { MessageCreate } from '../../../../components/Chat/type'
import Loader from '../../../../components/Loader'
import Modal from '../../../../components/Modal'
import RealtyDetails from '../../../../components/Realty/Details'
import Table from '../../../../components/Table'
import Text from '../../../../components/Text'
import routes from '../../../../config/routes'
import RealtyType, { STATUS } from '../../../../models/Realty'
import RoomType from '../../../../models/Room'
import UserType, { GENDER } from '../../../../models/User'
import isAdmin from '../../../../utils/is-admin'
import DisplayView from '../../DisplayView'
import PageContent from '../../PageContent'
import PageHeader from '../../PageHeader'
import { Info } from './styles'

interface Props {

}

const UserShowScreen: React.FC<Props> = () => {
  const params = useParams<{ id: string }>()
  const [room, setRoom] = useState<RoomType>()
  const [userEdit, setUser] = useState()
  const [realtiesKey, setRealtiesKey] = useState(0)
  const [viewRealty, setViewRealty] = useState()
  const [open, setOpen] = useState<boolean>(false)
  const { user, token } = useAuth()
  const history = useHistory()
  const [submittingMessage, setSubmittingMessage] = useState(false)

  const submitMessage = (message: MessageCreate) => {
    setSubmittingMessage(true)

    return Axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/users/${userEdit?.id}/chat`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { message: message.content },
    }).then(({ data }) => {
      history.push(routes.admin.chat.pathFor(btoa(JSON.stringify(data.data))))
      setSubmittingMessage(false)
    }).catch(() => {
      toast.error('Ocorreu um erro ao enviar mensagem')
      setSubmittingMessage(false)
    })
  }

  return (
    <div>
      <Modal
        title={`Sua mensagem para ${userEdit?.name}`}
        open={open}
        onToggle={open => {
          setOpen(open)
        }}
      >
        <div
          style={{ padding: '0 20px', flex: 1 }}
        >
        </div>
        <NewMessage
          attendantLogic={false}
          canUploadFiles={false}
          online={false}
          submitMessage={submitMessage}
          submittingMessage={submittingMessage}
        />
      </Modal>
      <Fetch
        url={`${process.env.REACT_APP_API_URL}/users/${params.id}`}
        onSuccess={({ data }) => {
          setUser(data.data)
          setRoom({
            ...data.data.chat_room,
            user: {
              ...data.data,
            },
          })
        }}
        loader={() => (
          <Loader
            darkMode
          />
        )}
      >
        {({ data }: { data: { data: UserType } }) => data && data.data && (
          <>
            <PageHeader
              title="Detalhes"
              subtitle={`Detalhes de ${data.data.name}`}
              side={isAdmin(user) ? (<>
                <Button
                  label="Editar usuário"
                  backgroundColor="darkBlue"
                  fontColor="white"
                  borderColor="lightGray"
                  small
                  onClick={() => {
                    history.push(routes.admin.user.edit.pathFor(data.data.id))
                  }}
                />
                <Button
                  label="Listar usuário"
                  backgroundColor="darkBlue"
                  fontColor="white"
                  borderColor="lightGray"
                  small
                  onClick={() => {
                    history.push(routes.admin.user.index.path)
                  }}
                />
              </>) : undefined}
            />
            <PageContent>
              <Info>
                <div
                  style={{ textAlign: 'center', marginBottom: 15 }}
                >
                  <Avatar
                    size={64}
                    img={data.data.avatar?.small || 'https://cdn.iptu.app/assets/img/person/placeholder.png'}
                  />
                </div>
                <DisplayView
                  items={[
                    [
                      {
                        label: 'ID',
                        value: data.data.id,
                        size: 20,
                      },
                      {
                        label: 'Nome',
                        value: data.data.name,
                        size: 55,
                      },
                      {
                        label: 'Email verificado',
                        value: data.data.verified ? 'Sim' : 'Não',
                        color: 'red',
                        size: 25,
                      },
                    ],
                    [
                      {
                        label: 'E-mail',
                        value: data.data.email,
                        size: 50,
                      },
                      // {
                      //   label: 'Telefone',
                      //   value: phone.format(data.data.phone) || '-',
                      //   size: 25,
                      // },
                      // {
                      //   label: 'Cidade',
                      //   value: data.data.city || '-',
                      //   size: 25,
                      // },
                    ],
                    [
                      {
                        label: 'CPF',
                        value: cpf.format(data.data.cpf) || '-',
                        size: 25,
                      },
                      // {
                      //   label: 'Ano de nascimento',
                      //   value: data.data.birth_year || '-',
                      //   size: 25,
                      // },
                      // {
                      //   label: 'Profissão',
                      //   value: data.data.profession || '-',
                      //   size: 25,
                      // },
                      // {
                      //   label: 'Gênero',
                      //   value: GENDER[data.data.gender] || '-',
                      //   size: 25,
                      // },
                    ],
                  ]}
                />
              </Info>
              {(room && room.attendant_id && room.attendant_id !== user.id && <Text
                tag="h2"
              >
                Em atendimento por {room.attendant.name}
              </Text>

              )}
              {(room && (!room.attendant_id || room.attendant_id === user.id) && <Button
                label="Chat"
                backgroundColor="darkBlue"
                fontColor="white"
                borderColor="lightGray"
                small
                onClick={() => {
                  if (room.attendant_id === user.id) {
                    history.push(
                      routes.admin.chat.pathFor(btoa(JSON.stringify(room))),
                    )
                  } else if (!room.attendant_id) {
                    setOpen(true)
                  }
                }}
              />)}
            </PageContent>
          </>
        )}
      </Fetch>
      {(userEdit && userEdit?.realties_count > 0 &&
        <PageContent>
          <Fetch
            key={realtiesKey}
            url={`${process.env.REACT_APP_API_URL}/realties?user_id=${params.id}`}
            loader={() => (
              <Loader
                darkMode
              />
            )}
          >
            {({ data }: any) => data && data.data && (
              <>
                <Table
                  header={[
                    'ID',
                    'Situação',
                    'Data de Cadastro',
                    'Tipo do Imóvel',
                    'Matrícula',
                    'Endereço',
                  ]}
                  items={data.data.map((realty: RealtyType) => [
                    realty.id,
                    STATUS[realty.status],
                    format(new Date(realty.created_at), 'dd/MM/yyyy HH:mm'),
                    `${realty.type} ${realty.custom_type ? `- ${realty.custom_type}` : ''}`,
                    realty.registration_number,
                    realty.address ? `${realty.address.street}, ${realty.address.number} - ${realty.address.complement} - ${realty.address.neighborhood} - ${realty.address.city} - ${realty.address.state}` : '-',
                  ])}
                  onClick={item => setViewRealty(item[0])}
                />

                {viewRealty && (
                  <Modal
                    title="Imóvel"
                    open
                    onToggle={() => setViewRealty(null)}
                  >
                    <RealtyDetails
                      realty={data.data.find((d: RealtyType) => {
                        return d.id === viewRealty
                      })}
                      onUpdated={() => setRealtiesKey(prev => prev + 1)}
                    />
                  </Modal>
                )}
              </>
            )}
          </Fetch>
        </PageContent>
      )}
    </div>
  )
}

export default UserShowScreen
